// Export Sortable Element Handle Directive
export const HandleDirective = {
  bind(el) {
    el.sortableHandle = true;
  },
};



// WEBPACK FOOTER //
// ./src/sorting/HandleDirective.js